import React, { useEffect, useState } from "react";
import "./Product_info.css";
import StarRatings from "react-star-ratings";
import Favourite_icon from "../../common-components/favourite-icon/Favourite_icon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faGlasses,
  faCheck,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import Want_buy_modal from "../../common-components/common-modals/want-buy-modal/Want_buy_modal";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Category,
  encodeId,
  get2DImage,
  get3DImage,
} from "../../../utils/common";
import Lense_prescription_modal from "../../common-components/common-modals/want-buy-modal/Lense_prescription_modal";
import Lens_Details_Modal from "../../common-components/common-modals/lens_details_modal/Lens_Details_Modal";
import { getAllCart, postCart } from "../../../features/cart/cartSlice";
import { getAllLensType } from "../../../features/master/masterSlice";
import Cookies from "js-cookie";
import VirtualTryOn from "../../virtual-try-on/Virtual_try_on";
import GLBViewer from "./GLBViewer";
import { frames } from "../../../tryon/lib/catalog";
import FuseButton from "../../common-components/common-btn/fuse_button/FuseButton";

/*
 * Fixed lens type IDs for the three "Buy Your Lenses" buttons.
 * Mapping (from the names the API returns): 14 = PROGRESSIVE LENS,
 * 15 = SV (single vision), 16 = D 28 BF (bifocal).
 * `kind` only controls the hover illustration + text.
 */
const LENS_TYPE_BUTTONS = [
  { id: 14, kind: "progressive", label: "Progressive Lens" },
  { id: 15, kind: "single", label: "Single Vision" },
  { id: 16, kind: "bifocal", label: "Bifocal" },
];

const LENS_INFO = {
  progressive: {
    title: "Progressive lenses",
    description:
      'Lenses that correct multiple fields of vision (near, intermediate, and distance). Requires a prescription with "add power" (ADD).',
  },
  bifocal: {
    title: "Bifocal lenses",
    description:
      'Lenses with two zones: distance vision on top and a segment for near vision at the bottom. Requires a prescription with "add power" (ADD).',
  },
  single: {
    title: "Single vision lenses",
    description: "Corrects one field of vision (near or distance).",
  },
};

/* Small lens drawing used in the hover box */
const LensIllustration = ({ kind }) => (
  <svg viewBox="0 0 120 80" className="lens-illus" aria-hidden="true">
    <defs>
      <clipPath id="lensClipShape">
        <path d="M12 22 C12 10 40 6 68 8 C96 10 112 22 108 40 C104 60 80 74 52 72 C26 70 12 44 12 22Z" />
      </clipPath>
      <pattern
        id="lensDotsBlue"
        width="6"
        height="6"
        patternUnits="userSpaceOnUse"
      >
        <circle cx="3" cy="3" r="1.7" fill="#29b6f6" />
      </pattern>
      <pattern
        id="lensDotsGrey"
        width="6"
        height="6"
        patternUnits="userSpaceOnUse"
      >
        <circle cx="3" cy="3" r="1.2" fill="#c9d3da" />
      </pattern>
    </defs>

    <path
      d="M12 22 C12 10 40 6 68 8 C96 10 112 22 108 40 C104 60 80 74 52 72 C26 70 12 44 12 22Z"
      fill="#f6fafc"
      stroke="#9aa5ad"
      strokeWidth="2"
    />

    <g clipPath="url(#lensClipShape)">
      {kind === "single" && (
        <ellipse cx="60" cy="38" rx="44" ry="26" fill="url(#lensDotsBlue)" />
      )}

      {kind === "bifocal" && (
        <>
          <rect x="0" y="0" width="120" height="80" fill="url(#lensDotsGrey)" />
          <rect x="0" y="0" width="120" height="44" fill="url(#lensDotsBlue)" />
          <path
            d="M40 50 H82 A2 2 0 0 1 84 52 V60 C84 66 78 70 62 70 C46 70 38 66 38 60 V52 A2 2 0 0 1 40 50Z"
            fill="url(#lensDotsBlue)"
          />
        </>
      )}

      {kind === "progressive" && (
        <>
          <rect x="0" y="0" width="120" height="80" fill="url(#lensDotsGrey)" />
          <path
            d="M20 14 H100 L88 40 L74 66 H46 L32 40 Z"
            fill="url(#lensDotsBlue)"
          />
        </>
      )}
    </g>
  </svg>
);

const Product_info = ({
  avgrating,
  product_id,
  product,
  variant,
  setVariant,
  ...props
}) => {
  const [wantbuy, setWantbuy] = useState(false);
  const handleShare = () => {
    const url =
      `${window.location.origin}/product-descrption/${encodeId(product_id)}` ||
      window.location.href;
    const title = product?.name || document.title;

    if (navigator.share) {
      navigator
        .share({
          title: title,
          text: `Check out this product: ${title}`,
          url: url,
        })
        .catch((err) => console.error("Share cancelled", err));
    } else {
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
        `Check out this product: ${title} - ${url}`,
      )}`;
      window.open(whatsappUrl, "_blank");
    }
  };
  const navigate = useNavigate();
  const location = useLocation();
  const is_signin = useSelector((state) => state.auth.is_signin);
  const handleBuyNow = () => {
    navigate("/login-product-detail");
  };
  const [lensemodal, setLensemodal] = useState(false);
  const [showTryOn, setShowTryOn] = useState(false);
  const dispatch = useDispatch();
  const isSignIn = useSelector((state) => state.auth.is_signin);

  // Power type tiles
  const lensType = useSelector((state) => state.master.lens_type);
  const [showLensDetails, setShowLensDetails] = useState(false);
  const [lensTypeId, setLensTypeId] = useState(null);

  // Holds the hovered lens type ID (14 / 15 / 16)
  const [hoveredLensType, setHoveredLensType] = useState(null);

  const [selectedLens, setSelectedLens] = useState(null);

  // Still fetched so we can show the backend name for each ID (falls back to our label)
  useEffect(() => {
    dispatch(getAllLensType());
  }, []);

  // Look up the backend name for a fixed ID, fallback to the local label
  const getLensTypeName = (id) => {
    const fromApi = lensType?.find((lt) => Number(lt?.id) === Number(id))?.name;
    const fromConfig = LENS_TYPE_BUTTONS.find((b) => b.id === Number(id))?.label;
    return fromApi || fromConfig || "";
  };

  const handleLensAdded = (typeId, lensInfo) => {
    if (!typeId) return;
    setSelectedLens({ typeId, ...lensInfo });
  };

  const handleRemoveLens = () => {
    setSelectedLens(null);
  };

  const lensesTotal = Number(selectedLens?.price) || 0;
  const grandTotal = (Number(product?.price) || 0) + lensesTotal;

  const [isAddingToCart, setIsAddingToCart] = useState(false);

  const addToCart = async (prescription_id) => {
    if (isAddingToCart) return;
    setIsAddingToCart(true);
    try {
      const data = {
        product_id: product?.id,
        variant_id: variant?.id,
        quantity: 1,
      };
      if (prescription_id) data.prescription_id = prescription_id;

      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(getAllCart(isSignIn));
        navigate("/cart");
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setIsAddingToCart(false);
    }
  };

  const vtoImage = get3DImage(product?.Product_Images) || "";
  const vto2DImage = get2DImage(product?.Product_Images);
  const hasVTOAsset =
    !!vtoImage || !!(vto2DImage && vto2DImage !== "NA");

  const isFrameCategory = !(
    Number(product?.p_category_id) === Number(Category.ContactLens) ||
    Number(product?.p_category_id) === Number(Category.Lenses) ||
    Number(product?.p_category_id) === Number(Category.Accessories)
  );

  const handleBuyNowClick = () => {
    if (selectedLens?.prescriptionId) {
      addToCart(selectedLens.prescriptionId); // one row: frame + lens
      return;
    }

    if (product?.p_category_id === 3 || product?.p_category_id === 1) {
      setLensemodal(true);
    } else {
      addToCart();
    }
  };

  const lensDiscount =
    selectedLens?.mrp && selectedLens?.price
      ? Math.round(
          ((selectedLens.mrp - selectedLens.price) / selectedLens.mrp) * 100,
        )
      : null;

  // Info card data for the hovered button
  const hoveredButton = hoveredLensType
    ? LENS_TYPE_BUTTONS.find((b) => b.id === hoveredLensType)
    : null;
  const hoveredLensInfo = hoveredButton
    ? {
        kind: hoveredButton.kind,
        title: LENS_INFO[hoveredButton.kind]?.title || getLensTypeName(hoveredButton.id),
        description: LENS_INFO[hoveredButton.kind]?.description || "",
      }
    : null;

  return (
    <>
      <section className="productinfodiv">
        <div className="row">
          <div className="col-md-8">
            <div className="leftsec">
              <p className="brandname">{product?.p_category?.name}</p>
              <p className="prod-name">
                {Number(product?.p_category_id) ===
                  Number(Category.ContactLens) ||
                Number(product?.p_category_id) === Number(Category.Lenses) ||
                Number(product?.p_category_id) === Number(Category.Accessories)
                  ? product?.name
                  : `${product?.Brand?.name}  ${product?.model_no}`}{" "}
              </p>
              <p className="prise">
                <span className="mainprise">₹{product?.price}-</span>
                <span className="oldprise">₹{product?.mrp}</span>
                <span className="discount">
                  {Math.round(
                    ((product.mrp - product.price) / product.mrp) * 100,
                  )}
                  % off
                </span>
                <span className="whtsap" onClick={handleShare}>
                  <img
                    className="icon"
                    src={
                      process.env.PUBLIC_URL + "/assets/images/icons/share.png"
                    }
                  />
                </span>
              </p>

              {selectedLens && (
                <div className="lens-price-list">
                  <p className="lensname">
                    {selectedLens?.name || selectedLens?.lensTypeName}
                  </p>
                  <p className="prise lensprise">
                    <span className="mainprise">₹{selectedLens?.price}-</span>
                    {selectedLens?.mrp ? (
                      <span className="oldprise">₹{selectedLens?.mrp}</span>
                    ) : null}
                    {lensDiscount ? (
                      <span className="discount">{lensDiscount}% off</span>
                    ) : null}

                    {/* Cancel lens: 4s undo window, lens is removed when the fuse burns out.
                        The key restarts/cancels a pending removal if a different lens is picked. */}
                    <span className="lens-remove-fuse">
                      <FuseButton
                        key={`${selectedLens?.typeId}-${
                          selectedLens?.prescriptionId ?? ""
                        }`}
                        label="Cancel"
                        undoLabel="Undo"
                        doneLabel="Cancelled"
                        icon={<FontAwesomeIcon icon={faXmark} />}
                        color="#f44336"
                        background="#fdecea"
                        fuseColor="#f44336"
                        size="sm"
                        radius={11}
                        undoWindow={4000}
                        fuse="outline"
                        commitOn="fuseEnd"
                        onCommit={handleRemoveLens}
                      />
                    </span>
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="rightsec">
              <Favourite_icon id={product?.id} />

              <p
                className="oneleftp"
                style={{
                  color: product?.available_stock <= 0 ? "red" : "inherit",
                }}
              ></p>

              <div className="btnvariantflex">
                <div className="colorvarientdiv">
                  {product?.Colour?.first_color && (
                    <div
                      className="color"
                      style={{ backgroundColor: product?.Colour?.first_color }}
                    ></div>
                  )}
                </div>

                <div className="bunowdiv">
                  {is_signin ? (
                    <button
                      type="button"
                      onClick={handleBuyNowClick}
                      className="buynowbtn"
                      disabled={isAddingToCart}
                      style={{ opacity: 1, cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        className="carticon"
                        icon={faCartShopping}
                      />
                      {isAddingToCart ? "Adding..." : "Buy Now"}
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={handleBuyNow}
                      className="buynowbtn"
                    >
                      <FontAwesomeIcon
                        className="carticon"
                        icon={faCartShopping}
                      />
                      Buy Now
                    </button>
                  )}

                  {product?.vto_enable && hasVTOAsset && (
                    <button
                      type="button"
                      onClick={() => setShowTryOn(true)}
                      className="votBtn"
                      style={{ opacity: 1, cursor: "pointer", marginTop: 10 }}
                    >
                      <FontAwesomeIcon className="votIcon" icon={faGlasses} />{" "}
                      Try on
                    </button>
                  )}

                  {lensesTotal > 0 && (
                    <p className="totalprise">
                      Total: <span>₹{grandTotal}</span>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="Product_details_sec">
          <div className="row">
            <div className="col-lg-12">
              <div className="contsec">
                <h6 className="prodtitle">Product Details</h6>

                {product?.Frame_Type?.name && (
                  <p className="discp frametype">
                    <span>Frame Type - </span>
                    {product?.Frame_Type?.name}
                  </p>
                )}
                {product?.Brand?.name && (
                  <p className="discp brand">
                    <span>Brand - </span>
                    {product?.Brand?.name}
                  </p>
                )}
                {product?.Gender?.name && (
                  <p className="discp gender">
                    <span>Gender - </span>
                    {product?.Gender?.name}
                  </p>
                )}
                {product?.Shape?.name && (
                  <p className="discp shape">
                    <span>Shape - </span>
                    {product?.Shape?.name}
                  </p>
                )}
                {product?.Material?.name && (
                  <p className="discp material">
                    <span>Material - </span>
                    {product?.Material?.name}
                  </p>
                )}
                {product?.Colour?.name && (
                  <p className="discp framecolour">
                    <span>Frame Colour - </span>
                    {product?.Colour?.name}
                  </p>
                )}
                {product?.lens_color?.name && (
                  <p className="discp lenscolour">
                    <span>Lens Colour - </span>
                    {product?.lens_color?.name}
                  </p>
                )}
                {product?.base_curve && (
                  <p className="discp basecurve">
                    <span>Base Curve - </span>
                    {product?.base_curve}
                  </p>
                )}
                {product?.water_content && (
                  <p className="discp watercontent">
                    <span>Water Content - </span>
                    {product?.water_content}
                  </p>
                )}
                {product?.modality && (
                  <p className="discp modality">
                    <span>Modality - </span>
                    {product?.modality}
                  </p>
                )}
                {product?.diameter && (
                  <p className="discp diameter">
                    <span>Diameter - </span>
                    {product?.diameter}
                  </p>
                )}
                {product?.dk_t && (
                  <p className="discp dkt">
                    <span>DK/T -</span>
                    {product?.dk_t}
                  </p>
                )}
                {product?.bo_code && (
                  <p className="discp bocode">
                    <span>BO Code - </span>
                    {product?.bo_code}
                  </p>
                )}
                {product?.size && (
                  <p className="discp size">
                    <span>
                      {" "}
                      {product?.p_category_id === Category.ContactLens
                        ? "Pack Size"
                        : "Size"}{" "}
                      -{" "}
                    </span>
                    {product?.size}
                  </p>
                )}
                {product?.total_measurements && (
                  <p className="discp totalmeasurements">
                    <span>Total Measurements - </span>
                    {product?.total_measurements}
                  </p>
                )}
                {product?.description && (
                  <p className="discp description">
                    <span>Description - </span>
                    {product?.description}
                  </p>
                )}
              </div>

              {isFrameCategory && (
                <div className="power-type-section">
                  <h6 className="power-type-heading">Buy Your Lenses</h6>
                  <div className="power-type-btns">
                    {LENS_TYPE_BUTTONS.map((item) => {
                      const isSelected =
                        Number(selectedLens?.typeId) === item.id;
                      return (
                        <button
                          type="button"
                          key={item.id}
                          className={`power-type-btn${
                            isSelected ? " selected" : ""
                          }`}
                          onMouseEnter={() => setHoveredLensType(item.id)}
                          onMouseLeave={() => setHoveredLensType(null)}
                          onFocus={() => setHoveredLensType(item.id)}
                          onBlur={() => setHoveredLensType(null)}
                          onClick={() => {
                            setLensTypeId(item.id); // 14 / 15 / 16
                            setShowLensDetails(true);
                          }}
                        >
                          {isSelected && (
                            <FontAwesomeIcon
                              icon={faCheck}
                              className="check-icon"
                            />
                          )}
                          {getLensTypeName(item.id)}
                        </button>
                      );
                    })}
                  </div>

                  {/* Info box shown below the three buttons on hover */}
                  <div className="lens-info-wrap">
                    {hoveredLensInfo && (
                      <div className="lens-info-card">
                        <div className="lens-info-img">
                          <LensIllustration kind={hoveredLensInfo.kind} />
                        </div>
                        <div className="lens-info-text">
                          <p className="lens-info-title">
                            {hoveredLensInfo.title}
                          </p>
                          {hoveredLensInfo.description && (
                            <p className="lens-info-desc">
                              {hoveredLensInfo.description}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        <Want_buy_modal
          product={product}
          variant={variant}
          product_id={product_id}
          show={wantbuy}
          onHide={() => setWantbuy(false)}
        />

        <Lense_prescription_modal
          product={product}
          variant={variant}
          product_id={product_id}
          show={lensemodal}
          onHide={() => setLensemodal(false)}
          redirectToCartOnSuccess={true}
        />

        <Lens_Details_Modal
          product={product}
          variant={variant}
          product_id={product_id}
          lensTypeId={lensTypeId}
          lensTypeName={getLensTypeName(lensTypeId)}
          onLensAdded={handleLensAdded}
          show={showLensDetails}
          onHide={() => setShowLensDetails(false)}
        />

        {showTryOn && (
          <VirtualTryOn
            isOpen={showTryOn}
            onClose={() => setShowTryOn(false)}
            category={product?.p_category}
            brand={product?.Brand}
            size={product?.size}
            total_measurements={product?.total_measurements}
            productImages={product?.Product_Images}
            glbModal={vtoImage}
            is3DVTO = {product?.is_3D_VTO}
            product={product}      // NEW: lets Details / Buy Now know which product is open
            variant={variant}      
          />
        )}
      </section>
    </>
  );
};

export default Product_info;